import React from 'react';
import {Segment, Grid, Header, Divider} from 'semantic-ui-react';
import _ from 'lodash';
import {convertValueToDollar} from 'common/utils';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Alert} from 'componentLibrary';
import {safeAdd} from 'common/utils';
import {toStartCase} from 'common/utils';

export const gridRow = (label, value) => (
  <Grid.Row key={label + value}>
    <Grid.Column width="6">{label}</Grid.Column>
    <Grid.Column width="10">
      <strong>{value}</strong>
    </Grid.Column>
  </Grid.Row>
);

export class BudgetSummary extends React.Component {
  render() {
    let {budget} = this.props;
    if (budget) {
      const bocRows = _.compact(
        _.map(budget.budgetSummary, (entry) => {
          if (entry.boc !== 'Indirect charges' && entry.boc !== 'Direct charges') {
            return gridRow(
              _.upperFirst(_.lowerCase(toStartCase(entry.boc))),
              convertValueToDollar(entry.total)
            );
          }
        })
      );

      const directCharges = _.find(
        budget.budgetSummary,
        (entry) => entry.boc === 'Direct charges'
      );
      const indirectCharges = _.find(
        budget.budgetSummary,
        (entry) => entry.boc === 'Indirect charges'
      );
      //  Hardcoding this for now, can add a check for program income field later
      const programIncome = 0;
      const fedShare = _.get(this.props, 'budget.share.fedShare', null);
      const appShare = _.get(this.props, 'budget.share.appShare', null);
      const appShareUpdated = _.get(this.props, 'budget.share.appShareUpdated');
      const totalBudget = safeAdd(fedShare, appShare);

      return (
        <React.Fragment>
          <Header as="h1">Budget summary</Header>
          <Segment>
            <Header as="h2">Budget object class</Header>
            <Grid>{bocRows}</Grid>
            <Divider />
            <Grid divided="vertically">
              {directCharges &&
                gridRow(
                  'Total direct charges',
                  convertValueToDollar(directCharges.total)
                )}
              {indirectCharges &&
                gridRow('Indirect charges', convertValueToDollar(indirectCharges.total))}
              {directCharges &&
                indirectCharges &&
                gridRow(
                  'Total direct and indirect charges',
                  convertValueToDollar(
                    safeAdd(indirectCharges.total, directCharges.total)
                  )
                )}
            </Grid>
            <Divider />
          </Segment>
          <Segment>
            <Header as="h2">Program income</Header>
            <Grid>{gridRow('Program income', convertValueToDollar(programIncome))}</Grid>
          </Segment>
          <Segment>
            <Header as="h2">Federal and non-federal resources</Header>
            {appShareUpdated && (
              <Alert
                size="mini"
                header="Approved exception to cost share rules"
                type="warning"
                dismissable={false}
              >
                The cost share rules for this grant have been adjusted per the approved
                waiver attachment.
              </Alert>
            )}
            <Grid>
              {gridRow('Federal resources', convertValueToDollar(fedShare))}
              {gridRow('Non-federal resources', convertValueToDollar(appShare))}
              {gridRow('Total budget', convertValueToDollar(totalBudget))}
            </Grid>
          </Segment>
        </React.Fragment>
      );
    } else return null;
  }
}

export default connectDynamic(BudgetSummary);
